import { createColumnHelper } from '@tanstack/react-table';
import { formatCurrency } from '@cks-internal/react-base';
import { Badge, Box, Text } from '@chakra-ui/react';
import { WexCardTransaction, WexCardTransactionType } from '../types';
import { formatDateTimeDayJs } from '../../../../common/formatters.ts';
import dayjs from 'dayjs';

const columnHelper = createColumnHelper<WexCardTransaction>();

export const useWexCardTransactionColumns = () => {
  return [
    columnHelper.accessor('TransactionDate', {
      header: 'Transaction Date',
      cell: (info) => formatDateTimeDayJs(dayjs(info.getValue()))
    }),
    columnHelper.accessor('MerchantName', {
      header: 'Merchant',
      cell: (info) => (
        <Box>
          <Text fontWeight='medium'>{info.getValue() || 'N/A'}</Text>
          {info.row.original.MerchantAddress && (
            <Text fontSize='sm' color='gray.600'>
              {info.row.original.MerchantAddress}
            </Text>
          )}
        </Box>
      )
    }),
    columnHelper.accessor('Amount', {
      header: 'Amount',
      cell: (info) => {
        return (
          <Box>
            <Box>{info.getValue()}</Box>
            <Box>{info.row.original.BillingCurrency}</Box>
          </Box>
        );
      }
    }),
    columnHelper.accessor('Type', {
      header: 'Type',
      cell: (info) => (
        <Badge colorPalette={info.getValue() === WexCardTransactionType.Authorization ? 'blue' : 'green'}>
          {info.getValue() === WexCardTransactionType.Authorization ? 'Authorization' : 'Transaction'}
        </Badge>
      )
    }),
    columnHelper.accessor('WasApproved', {
      header: 'Status',
      cell: (info) => (
        <Badge colorPalette={info.getValue() ? 'green' : 'red'}>
          {info.getValue()
            ? info.row.original.Type == WexCardTransactionType.Transaction
              ? 'Posted'
              : 'Authorized'
            : 'Declined'}
        </Badge>
      )
    }),
    columnHelper.accessor('ResponseCode', {
      header: 'Response',
      cell: (info) => (
        <Box>
          <Text fontWeight='medium'>{info.getValue()}</Text>
          {info.row.original.ResponseCodeDescription && (
            <Text fontSize='sm' color='gray.600'>
              {info.row.original.ResponseCodeDescription}
            </Text>
          )}
        </Box>
      )
    }),
    columnHelper.accessor('RemainingCredit', {
      header: 'Remaining Credit',
      cell: (info) => (info.getValue() !== null ? formatCurrency(info.getValue()!) : 'N/A')
    }),
    columnHelper.accessor('MccCode', {
      header: 'MCC Code',
      cell: (info) => info.getValue() || 'N/A'
    }),
    columnHelper.accessor('PostingDate', {
      header: 'Posting Date',
      cell: (info) => (info.getValue() ? formatDateTimeDayJs(dayjs(info.getValue())) : '')
    })
  ];
};
